var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47786 0.904297C7.74023 0.904297 8.76358 1.92765 8.76358 3.19001V4.71382C8.76358 5.97619 7.74023 6.99953 6.47786 6.99953C5.2155 6.99953 4.19215 5.97619 4.19215 4.71382V3.19001C4.19215 1.92765 5.2155 0.904297 6.47786 0.904297ZM11.8112 11.571V11.0162C11.8112 8.58842 9.0026 6.99953 6.47786 6.99953C3.95313 6.99953 1.14453 8.58842 1.14453 11.0162V11.571C1.14453 11.9918 1.48565 12.3329 1.90644 12.3329H11.0493C11.4701 12.3329 11.8112 11.9918 11.8112 11.571Z",
    stroke: "#BFBFBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54253 1.04004C10.4224 1.35807 11.0512 2.20073 11.0512 3.19026V3.95217C11.0512 4.94042 10.4054 5.91891 9.52734 6.23788C10.0411 5.53787 10.2976 4.64877 10.2968 3.5706C10.2961 2.49242 10.0447 1.6489 9.54253 1.04004ZM13.3369 12.3331H14.0988C14.5196 12.3331 14.8607 11.992 14.8607 11.5712C14.8607 11.3863 14.8607 11.2014 14.8607 11.0164C14.8607 9.36318 13.5582 8.09895 11.93 7.46057C11.93 7.46057 14.0988 9.2855 13.3369 12.3331Z",
    fill: "#BFBFBF",
    stroke: "#BFBFBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.1e16539aaaf0aa8b27de3e558f292c77.svg";
export { ForwardRef as ReactComponent };